// Action types for Master Time Frame Interval

// Get Master Time Frame Interval List
export const GET_MASTER_TIME_FRAME_INTERVAL_LIST =
  "GET_MASTER_TIME_FRAME_INTERVAL_LIST";
export const GET_MASTER_TIME_FRAME_INTERVAL_LIST_SUCCESS =
  "GET_MASTER_TIME_FRAME_INTERVAL_LIST_SUCCESS";
export const GET_MASTER_TIME_FRAME_INTERVAL_LIST_FAILURE =
  "GET_MASTER_TIME_FRAME_INTERVAL_LIST_FAILURE";
